import { detectBrowser, isAndroid, isIos, isMobile } from './mobile'
import { checkIsNativeApp } from './nativeApp'

/**
 * Client-side counterpart of `getDeviceInfo(headers)` from mm_client_next.
 * Static facts about the device (they don't change during the session).
 * For layout decisions (mobile vs desktop view) use `ViewContext` instead.
 */
export const getDeviceInfo = (): app.Device => {
  const ua = navigator.userAgent || ''
  const platform = ((navigator as any).userAgentData?.platform || navigator.platform || '').toLowerCase()

  return {
    isIOS: isIos(),
    isAndroid: isAndroid(ua),
    isWindows: platform.startsWith('win'),
    isNativeApp: checkIsNativeApp(),
    isMacOS: platform.startsWith('mac') && !isIos(),
    browser: detectBrowser(ua),
    isMobile: isMobile(ua),
    language: navigator.language?.startsWith('pl') ? 'pl' : 'en',
  }
}
